export default {
  methods: {
    isEmpty(str) {
      return (!str || str.length === 0 );
    },
    telUrl(phone) {
      return "tel:" + phone;
    },
    phoneString(phone) {
      const isValidPhone = /^\d{10}$/.test(phone);
      if (isValidPhone) {
        return "+7" + phone;
      }
      return phone;
    },
    priceFormat(value, round) {
      if (round) {
        const roundValue = Math.round(value * 100) / 100;
        return new Intl.NumberFormat('ru-RU').format(roundValue);
      }
      return new Intl.NumberFormat('ru-RU').format(value);
    },
    paymentTypeString(flag) {
      switch (flag) {
        case 0: return "Нал"
        case 1: return "ООО"
        case 2: return "ИП"
        case 3: return "СМЗ"
        default: return "Неизвестно"
      }
    },
    paymentTypeIcon(flag) {
      switch (flag) {
        case 0: return {icon:"coins", title: "Нал"}
        case 1: return {icon:"file-invoice-dollar", title: "НДС"}
        case 2: return {icon:"user", title: "бех НДС"}
        case 3: return {icon:"file-invoice-dollar", title: "СМЗ"}
        default: return {icon:"user-slash", title: "Неизвестно"}
      }
    },
    yesOrNoText(flag) {
      return flag ? "Да" : "Нет";
    },
    yesOrNoIcon(flag) {
      if (flag) {
        return {
          icon: "check",
          style: {
            color: 'darkgreen'
          }
        };
      } else {
        return {
          icon: "times",
          style: {
            color: 'darkred'
          }
        };
      }
    },
    yesOrNoPayIcon(flag) {
      if (flag) {
        return {
          icon: "users",
          style: {
            color: 'darkgreen'
          }
        };
      } else {
        return {
          icon: "users",
          style: {
            color: 'darkred'
          }
        };
      }
    },
    readOnly(row) {
      if (!row.item.read_only) {
        return {
          icon: "pen",
          style: {
            color: 'darkgreen'
          }
        }
      } else {
        return {
          icon: "pen",
          style: {
            color: 'gray'
          }
        }
      }
    },
    showGenerateFileError(title, message) {
      this.$bvToast.toast(message, {
        title: title,
        variant: 'danger',
        autoHideDelay: 3000,
        solid: true
      });
    },
    showSubmitError(message) {
      this.$bvToast.toast(message, {
        title: 'Ошибка сохранения',
        variant: 'danger',
        autoHideDelay: 3000,
        solid: true
      });
    },
    showToast(message, title, variant) {
      this.$bvToast.toast(message, {
        title: title,
        variant: variant,
        solid: true,
        autoHideDelay: 3000
      });
    },
    showError(message, description) {
      const h = this.$createElement
      const messageVNode = h('div', { class: ['foobar'] }, [
        h('p', [ message ]),
        h('p', { class: ['text-small'] }, [ description ])
      ])
      this.$bvModal.msgBoxOk([messageVNode], {
        title: 'Ошибка',
        headerBgVariant: 'danger',
        headerTextVariant: 'light'
      });
    },
    showModalDelete(title, message, okAction) {
      this.$bvModal.msgBoxConfirm(message, {
        title: title,
        buttonSize: 'sm',
        okTitle: `${this.$t('message.actions.remove')}`,
        cancelTitle: `${this.$t('message.actions.cancel')}`,
        okVariant:'danger',
        headerBgVariant: 'danger',
        headerTextVariant: 'light'
      }).then(value => {
        if (value && value === true) {
          okAction();
        }
      });
    },
    showSuccess(message, description) {
      const h = this.$createElement
      const messageVNode = h('div', { class: ['foobar'] }, [
        h('p', [ message ]),
        h('p', { class: ['text-small'] }, [ description ])
      ])
      this.$bvModal.msgBoxOk([messageVNode], {
        title: 'Успешно!',
        headerBgVariant: 'success',
        headerTextVariant: 'light'
      });
    },
    async showAcceptModal(title, message, variant) {
      return await this.$bvModal.msgBoxConfirm(message, {
        title: title,
        buttonSize: 'sm',
        okTitle: `${this.$t('message.actions.continue')}`,
        cancelTitle: `${this.$t('message.actions.cancel')}`,
        okVariant: variant || 'danger',
        headerBgVariant: variant || 'danger',
        headerTextVariant: 'light'
      }).then(value => {
        return value && value === true;
      });
    },
    isNumber(value) {
      return typeof value === 'number' && isFinite(value);
    },
    isNumberOrNull(value) {
      return value === null || (typeof value === 'number' && isFinite(value));
    },
    isNumberObject(n) {
      return (Object.prototype.toString.apply(n) === '[object Number]');
    },
    isCustomNumber(n){
      return this.isNumber(n) || this.isNumberObject(n);
    },
    dateValidation(dateStr) {
      if (!dateStr) {
        return false;
      }
      const dateObj = new Date(dateStr);
      return !isNaN(dateObj.getTime()) && dateObj.getTime() !== 0;
    },
    isDateValid(dateStr) {
      return !isNaN(new Date(dateStr));
    },
    sortCompare(a, b, key) {
      if (key === 'id') {
        if (a.id === 0 && b.id !== 0) { return 1; }
        if (b.id === 0 && a.id !== 0) { return -1; }
        if (a.id === 0 && b.id === 0) { return 0; }
        return a.id - b.id;
      }
      return null;
    },
    sortPeriodCompare(aRow, bRow, key) {
      if (key === 'period') {
        const startDateA = new Date(aRow.start_date).getTime();
        const startDateB = new Date(bRow.start_date).getTime();

        if (startDateA < startDateB) {
          return -1;
        } else if (startDateA > startDateB) {
          return 1;
        } else {
          const endDateA = new Date(aRow.end_date).getTime();
          const endDateB = new Date(bRow.end_date).getTime();

          if (endDateA < endDateB) return -1;
          if (endDateA > endDateB) return 1;

          return 0;
        }
      }
      return null;
    },
    async sortChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      await this.getItems();
    },
    transliterate(text) {
      const map = {
        а: 'a', б: 'b', в: 'v', г: 'g', д: 'd',
        е: 'e', ё: 'yo', ж: 'zh', з: 'z', и: 'i',
        й: 'j', к: 'k', л: 'l', м: 'm', н: 'n',
        о: 'o', п: 'p', р: 'r', с: 's', т: 't',
        у: 'u', ф: 'f', х: 'h', ц: 'ts', ч: 'ch',
        ш: 'sh', щ: 'shch', ъ: '', ы: 'y', ь: '',
        э: 'e', ю: 'yu', я: 'ya'
      };
      return text
        .toLowerCase()
        .split('')
        .map(char => map[char] || char)
        .join('');
    },
    generateVacancyTextString(item) {
      if (!item) return '';

      const textConfig = [
        { key: 'workers_count', label: 'Количество исполнителей' },
        { key: 'duties', label: 'Обязанности'},

        // Требования
        { label: 'Требования', type: 'separator' },
        { key: 'sex', label: 'Пол' },
        { key: 'age_range', label: 'Возраст' },
        { key: 'citizenships', label: 'Гражданство', catalogRef: 'citizenshipsCatalog' },
        { key: 'criminal_record', commentKey: 'criminal_record_comment', label: 'Судимость', type: 'checkbox-input' },
        { key: 'work_exp', label: 'Опыт работы' },
        { key: 'physical_work', commentKey: 'physical_work_comment', label: 'Физический труд', type: 'checkbox-input' },
        { key: 'expectations', label: 'Ожидания от кандидата' },
        { key: 'certificates', arrayMappings: [{ key: 'driver_license_categories', catalogRef: 'driverLicenseCategoriesCatalog' }], label: 'Удостоверения / права', type: 'complex' },
        { key: 'medical_book', commentKey: 'medical_book_comment', label: 'Медкнижка', type: 'checkbox-input' },

        // Условия
        { label: 'Условия', type: 'separator' },
        {
          key: 'employment',
          arrayMappings: [{ key: 'employment_types', optionsRef: 'employmentTypesOptions' }],
          label: 'Оформление',
          type: 'complex'
        },
        { key: 'employment_categories', label: 'Занятость', catalogRef: 'employmentCategoriesCatalog' },
        {
          key: 'schedule',
          arrayMappings: [{ key: 'schedule_time_of_day', optionsRef: 'shiftOptions' }],
          extraKey: 'night_coefficient',
          extraLabel: 'Ночной коэффициент',
          label: 'График',
          type: 'complex'
        },
        {
          key: 'output_format',
          arrayMappings: [{ key: 'output_format', optionsRef: 'outputFormatOptions' }],
          label: 'Формат выхода',
          type: 'complex'
        },
        { key: 'shift_hours', label: 'Часы работы' },
        { key: 'break_hours', label: 'График перерывов' },
        { key: 'work_rate', label: 'Выработка (норма)' },
        { key: 'salary', label: 'Ставка' },
        { key: 'salary_smz', label: 'Ставка СМЗ' },
        { key: 'salary_hand', commentKey: 'salary_hand_comment', label: 'Карта / на руки', type: 'checkbox-input' },
        { key: 'payment_period', label: 'Периодичность выплат' },
        { key: 'probation', label: 'Стажировка' },
        { key: 'compensation', label: 'Компенсации' },
        { key: 'meals', label: 'Питание' },
        { key: 'accommodation', label: 'Проживание' },
        { key: 'brigadier_bonus', label: 'Премия бригадиру' },
        { key: 'uniform', label: 'Униформа' },
        { key: 'wardrobe', label: 'Гардероб' },
        { key: 'indoor_conditions', label: 'Характеристика помещений' },
        { key: 'transport', label: 'Как добраться' },
        { key: 'corp_transport', commentKey: 'corp_transport_comment', label: 'Корпоративный транспорт', type: 'checkbox-input' },
        { key: 'security_service', commentKey: 'security_service_comment', label: 'Служба безопасности', type: 'checkbox-input' },
        { key: 'access_mode', commentKey: 'access_mode_comment', label: 'Пропускной режим', type: 'checkbox-input' },
        { key: 'prohibited', label: 'Ограничения на объекте' },
      ];

      let text = `Вакансия: ${item.vacancy_name}\n`;

      const parseArray = (array, optionsRef, catalogRef) => {
        if (!array || !Array.isArray(array)) return '';

        const options = optionsRef ? this[optionsRef] : null;
        const catalog = catalogRef ? this[catalogRef] : null;

        return array.map(val => {
          if (options) {
            const found = options.find(opt => opt.value === val);
            if (found) return found.text;
          }
          if (catalog) {
            const found = catalog.find(cat => cat.id === val);
            if (found) return found.name;
          }
          return val;
        }).filter(Boolean).join(', ');
      };

      textConfig.forEach(field => {
        if (field.type === 'separator') {
          text += `\n${field.label}:\n`;
          return;
        }

        if (field.key === 'age_range') {
          const { age_from, age_to } = item;
          if (age_from || age_to) {
            const ageParts = [];

            if (age_from) ageParts.push(`от ${age_from}`);

            if (age_to) ageParts.push(`до ${age_to}`);

            text += `- ${field.label}: ${ageParts.join(' ')};\n`;
          }
          return;
        }

        const value = item[field.key];

        if (field.type === 'checkbox-input') {
          const comment = typeof item[field.commentKey] === 'string' ? item[field.commentKey].trim() : '';

          if (value || comment) {
            const boolText = value ? 'Да' : 'Нет';
            text += `- ${field.label}: ${comment ? `${boolText} (${comment})` : boolText};\n`;
          }
          return;
        }

        if (field.type === 'complex') {
          const parts = [];

          if (typeof value === 'string' && value.trim()) {
            parts.push(value.trim());
          }

          if (field.arrayMappings) {
            field.arrayMappings.forEach(mapping => {
              const parsed = parseArray(item[mapping.key], mapping.optionsRef, mapping.catalogRef);
              if (parsed) parts.push(parsed);
            });
          }

          if (field.extraKey && item[field.extraKey]) {
            parts.push(`${field.extraLabel || field.extraKey}: ${String(item[field.extraKey]).trim()}`);
          }

          if (parts.length > 0) {
            text += `- ${field.label}: ${parts.join('; ')};\n`;
          }
          return;
        }

        if (Array.isArray(value)) {
          const parsedPart = parseArray(value, field.optionsRef, field.catalogRef);
          if (parsedPart) {
            text += `- ${field.label}: ${parsedPart};\n`;
          }
          return;
        }

        if (value !== null && value !== undefined && value !== '') {
          text += `- ${field.label}: ${value};\n`;
        }
      });

      return text;
    },
    validateEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    getBadgeStyle(bgColor) {
      if (!bgColor || !bgColor.startsWith('#')) {
        return { backgroundColor: '#b5b1b1', color: '#000000' };
      }

      return {
        backgroundColor: bgColor,
        color: this.getTextColorForBackground(bgColor),
        border: '1px solid rgba(0,0,0,0.1)',
      };
    },
    getTextColorForBackground(hexColor) {
      const r = parseInt(hexColor.substr(1, 2), 16);
      const g = parseInt(hexColor.substr(3, 2), 16);
      const b = parseInt(hexColor.substr(5, 2), 16);
      const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
      return (yiq >= 128) ? '#000000' : '#FFFFFF';
    },
    onlyNumbers(e) {
      const serviceKeys = ['Backspace', 'Tab', 'Enter', 'Delete', 'ArrowLeft', 'ArrowRight', 'Home', 'End'];

      if (serviceKeys.includes(e.key)) {
        return;
      }

      if (!/\d/.test(e.key)) {
        e.preventDefault();
      }
    },
    preventMinus(event) {
      if (event.key === '-') {
        event.preventDefault();
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/utilites/helpers.js